<div class="input-label">
  {{ translationPrefix() + 'category' | translate }}
</div>
<p-select
  [options]="categories"
  [(ngModel)]="selectedCategory"
  optionLabel="name"
  [placeholder]="translationPrefix() + 'categoryPlaceholder' | translate"
  class="category-select" />

<app-file-upload (fileSelected)="onFileSelected($event)"></app-file-upload>

<button
  class="primary-btn icon-btn"
  [disabled]="!selectedCategory || !file || importState() === 'IN_PROGRESS'"
  [ngClass]="{ 'disabled-btn': !selectedCategory || !file }"
  (click)="uploadTemplate()">
  @if (importState() !== 'IN_PROGRESS') {
    <img src="assets/icons/check.svg" />
    {{ translationPrefix() + 'finishImport' | translate }}
  } @else {
    <span class="loader"></span>
  }
</button>

@if (importState() === 'SUCESS') {
  <p-message severity="success" class="result-msg">
    <span>{{ translationPrefix() + 'success' | translate }}</span>
  </p-message>
}

@if (importState() === 'FAIL') {
  <p-message severity="error" class="result-msg">
    <span>{{ translationPrefix() + 'fail' | translate }}</span>
  </p-message>
}
